import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../utils/routes";

export default function useRNPurchaseProcess() {
  const navigate = useNavigate();
  const location = useLocation();
  const listener = (event) => {
    if (!window?.isRNWebView) return;
    const data = JSON.parse(event.data);
    if (data.type === "SUCCESS_PURCHASE") {
      location.href = location.origin + location.pathname + location.search;
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
      navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
    }
  };

  useEffect(() => {
    window.addEventListener("message", listener);
    document.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
      document.addEventListener("message", listener);
    };
  }, []);
}
